import React from 'react';

export default class Table extends React.Component {
  constructor(props) {
    super(props);
  }

  buildHeader(header) {
    if (header) {
      return (
        <thead>
          <tr>{header.map(item => <th>{item}</th>)}</tr>
        </thead>
      );
    } else {
      return '';
    }
  }

  buildBody(rows) {
    if (rows) {
      return (
        <tbody>
          {rows.map(col => (
            <tr>{col.map(cell => {
                let customArgs = null;
                let value = '';
                // cell ที่ถูก rowSpan ของแถวก่อนหน้าครอบไว้แล้ว -> ไม่ต้อง render td
                if (cell && cell.skip) return null;
                if (cell && typeof cell === 'object' && !React.isValidElement(cell)) {
                  customArgs = {
                    className: cell.customStyle,
                    rowSpan: cell.rowSpan,
                    style: cell.style,
                  };
                  value = cell.value;
                } else {
                  value = cell;
                }
                return <td {...customArgs}>{value}</td>;
              })}
            </tr>
          ))}
        </tbody>
      );
    } else {
      return '';
    }
  }

  render() {
    return (
      <table>
        {this.buildHeader(this.props.header)}
        {this.buildBody(this.props.data, this.props.styles)}
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/table/Table.js